import React from "react";

const FOCUS = [
  {
    label: "Multi-family",
    body:
      "Workforce and middle-market rental housing in supply-constrained submarkets — assets with durable, needs-based demand.",
    testid: "focus-multifamily",
  },
  {
    label: "Mixed-use",
    body:
      "Residential layered over street-level retail in walkable, transit-oriented locations — diversified cash flow within a single asset.",
    testid: "focus-mixed-use",
  },
  {
    label: "Retail",
    body:
      "Grocery-anchored and service-led centers with long-tenured tenants and rent rolls that hold through cycles.",
    testid: "focus-retail",
  },
];

export default function WhatWeDo() {
  return (
    <section
      id="what-we-do"
      data-testid="what-we-do-section"
      className="bg-white py-24 lg:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 mb-16 lg:mb-20">
          <div className="lg:col-span-5">
            <p className="eyebrow mb-6">What we do</p>
            <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-[56px] leading-[1.05] tracking-tight text-[#1f3a2e] font-light">
              Boutique real<br />
              estate, owned<br />
              with conviction.
            </h2>
          </div>
          <div className="lg:col-span-6 lg:col-start-7 flex items-end">
            <p className="text-[#5e6e63] text-lg leading-relaxed font-light">
              Wintercove is a boutique investor — small, selective, and hands-on
              with every asset we own. We move with the discipline of an
              institutional shop while staying nimble enough to pursue
              opportunities others overlook. We focus on three asset types:
              multi-family residential, mixed-use, and retail.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-[#1f3a2e]/15">
          {FOCUS.map((f, idx) => (
            <article
              key={f.testid}
              data-testid={f.testid}
              className="bg-[#1f3a2e] p-10 lg:p-12 flex flex-col gap-6 hover:bg-[#142a20] transition-colors duration-300"
            >
              <div className="flex items-baseline gap-6">
                <span className="font-serif-display text-2xl text-white/55 font-light">
                  {String(idx + 1).padStart(2, "0")}
                </span>
                <div className="h-px flex-1 bg-white/20" />
              </div>
              <h3 className="font-serif-display text-2xl lg:text-[28px] text-white font-normal leading-tight tracking-tight">
                {f.label}
              </h3>
              <p className="text-white/75 text-base lg:text-[17px] leading-relaxed font-light">
                {f.body}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
